import { put, call, fork, all, takeLatest, select } from "redux-saga/effects";
import * as types from "~/store/rebooking/rebookingType";
import * as api from "~/store/rebooking/rebookingApi";
import { getBaseUrl } from "~/utils/getBaseUrl";

// All Rebooking
function* requestGetAllRebooking({ data }) {
  try {
    yield put({ type: types.SHOW_LOADING });
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(api.apiGetAllRebooking, baseUrl, data);
    const { error_message, error_code } = response.data;
    if (error_message) throw new Error(error_message);
    if (response.status !== 200 || error_code) throw new Error("Server error");
    yield put({ type: types.GET_ALL_REBOOKING_SUCCESS, data: response.data });
    yield put({ type: types.HIDE_LOADING });
  } catch (error) {
    yield put({
      type: types.GET_ALL_REBOOKING_FAILURE,
      errorMessage: error.message || error
    });
    yield put({ type: types.HIDE_LOADING });
  }
}

function* watchRequestGetAllRebooking() {
  yield takeLatest(types.GET_ALL_REBOOKING_REQUEST, requestGetAllRebooking);
}

// All patient rebooking
function* requestGetAllPatientRebooking({ data }) {
  try {
    yield put({ type: types.SHOW_LOADING });
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(api.apiGetAllPatientRebooking, baseUrl, data);
    if (response.status !== 200) throw new Error("Server error");
    const responseData = response.data;
    const isValidData = Array.isArray(responseData);
    yield put({
      type: types.GET_ALL_PATIENT_REBOOKING_SUCCESS,
      searchHistoryList: isValidData ? responseData : []
    });
    yield put({ type: types.HIDE_LOADING });
  } catch (error) {
    yield put({
      type: types.GET_ALL_PATIENT_REBOOKING_FAILURE,
      errorMessage: error.errorMessage
    });
    yield put({ type: types.HIDE_LOADING });
  }
}
function* watchRequestGetAllPatientRebooking() {
  yield takeLatest(
    types.GET_ALL_PATIENT_REBOOKING_REQUEST,
    requestGetAllPatientRebooking
  );
}

function* getRebookingByPatientId({ data }) {
  try {
    yield put({ type: types.SHOW_LOADING });
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(api.getRebookingByPatientId, baseUrl, data);
    const { error_message, error_code } = response.data;
    if (error_message) throw new Error(error_message);
    if (response.status !== 200 || error_code) throw new Error("Server error");
    yield put({ type: types.GET_ALL_REBOOKING_SUCCESS, data: response.data });
    yield put({ type: types.HIDE_LOADING });
  } catch (error) {
    yield put({
      type: types.GET_ALL_REBOOKING_FAILURE,
      errorMessage: error.message || error
    });
    yield put({ type: types.HIDE_LOADING });
  }
}

function* watchGetRebookingByPatientId() {
  yield takeLatest(types.GET_REBOOKING_BY_PATIENT_ID, getRebookingByPatientId);
}

function* getAllRebookingFromHistory({ data }) {
  try {
    yield put({ type: types.SHOW_LOADING });
    const baseUrl = yield select(state => getBaseUrl(state.hospital));
    const response = yield call(api.getAllRebookingFromHistory, baseUrl, data);
    const { error_message, error_code } = response.data;
    if (error_message) throw new Error(error_message);
    if (response.status !== 200 || error_code) throw new Error("Server error");
    yield put({ type: types.GET_ALL_REBOOKING_SUCCESS, data: response.data });
    yield put({ type: types.HIDE_LOADING });
  } catch (error) {
    yield put({
      type: types.GET_ALL_REBOOKING_FAILURE,
      errorMessage: error.message || error
    });
    yield put({ type: types.HIDE_LOADING });
  }
}

function* watchGetAllRebookingFromHistory() {
  yield takeLatest(
    types.GET_ALL_REBOOKING_FROM_HISTORY,
    getAllRebookingFromHistory
  );
}

export default function* root() {
  yield all([
    fork(watchRequestGetAllRebooking),
    fork(watchRequestGetAllPatientRebooking),
    fork(watchGetRebookingByPatientId),
    fork(watchGetAllRebookingFromHistory)
  ]);
}
